import script from "./MarketDataDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketDataDashboard.vue?vue&type=script&setup=true&lang=js"

import "./MarketDataDashboard.vue?vue&type=style&index=0&id=461f28c7&lang=scss"

const __exports__ = script;

export default __exports__